import { render, staticRenderFns } from "./ProjectInvitations.vue?vue&type=template&id=38cd2e1b&"
import script from "./ProjectInvitations.vue?vue&type=script&lang=js&"
export * from "./ProjectInvitations.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInvitations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports